import axios from '../../../axios-marketplace';

const aprovar = (idCompra, data) => axios.put(`/compras/${idCompra}/aprovar-admin`, data);

export default {
  aprovar,
};
